import { HomeOutlined } from '@ant-design/icons'
import { SelectLang as UmiSelectLang } from '@umijs/max'
import React from 'react'

export type SiderTheme = 'light' | 'dark'

export function SelectLang() {
  return (
    <UmiSelectLang
      style={{
        padding: 4
      }} />
  )
}

export function Question() {
  return (
    <a
      href='https://www.dakedake.com'
      rel='noreferrer'
      style={{
        display: 'flex',
        height: 26
      }}
      target='_blank'>
      <HomeOutlined />
    </a>
  )
}
